import {createContext} from "react";

export const RecommendationFormContext = createContext({
    getValueByFormFieldName: () => {},
})
